/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Dashboard Detail Management View Page
 */

// Dependencies
import PropTypes from 'prop-types';
import { DownOutlined, FilterOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { useState } from 'react';

// Helpers

// Styles
import styles from './styles.module.css';

function TableFilter({ menuItems, onSelectItem, label }) {
  const [itemSelected, setItemSelected] = useState(0);
  const maxLength = 9;
  const maxCharName = 5;

  const onSelectItemMenu = (key, value) => {
    setItemSelected(key);
    onSelectItem(key, value);
  };

  const menu = (
    <Menu selectable>
      {menuItems.map(({ key, value }) => (
        <Menu.Item onClick={() => onSelectItemMenu(key, value)} key={key}>
          {value}
        </Menu.Item>
      ))}
    </Menu>
  );
  let filterBy = '';
  filterBy = menuItems[itemSelected].value;

  return (
    <Dropdown className="ml-3" key={1} overlay={menu} trigger={['click']}>
      <div className={styles.customDropdownInput}>
        <div className="flex flex-row w-full">
          <FilterOutlined className={styles.customDropdownPrefix} />
          <span className="text-grayFontInput text-base invisible lg:visible">
            {`${label}: `}
            {filterBy.length >= maxLength
              ? `${filterBy.substr(0, maxCharName)}...`
              : filterBy}
          </span>
        </div>
        <DownOutlined className={styles.customDropdownArrow} />
      </div>
    </Dropdown>
  );
}

/**
 * Component definition of proptypes
 */
TableFilter.propTypes = {
  menuItems: PropTypes.array,
  label: PropTypes.string,
  onSelectItem: PropTypes.func
};

export default TableFilter;
